import { render, staticRenderFns } from "./HeaderCom.vue?vue&type=template&id=420edec6&scoped=true"
import script from "./HeaderCom.vue?vue&type=script&lang=js"
export * from "./HeaderCom.vue?vue&type=script&lang=js"
import style0 from "./HeaderCom.vue?vue&type=style&index=0&id=420edec6&prod&scoped=true&lang=css"
import style1 from "./HeaderCom.vue?vue&type=style&index=1&id=420edec6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420edec6",
  null
  
)

export default component.exports